module.exports = __webpack_public_path__ + "img/top_safe01.5e16e503.png";